export const INCUBATOR_PIPELINE_OPTIONS = [
  "Prospect-Active",
  "Prospect-Inactive",
  "Active-Early Stage",
  "Active-Growth Stage",
  "Graduated-Moved Within the Landing",
  "Graduated-Left Region",
  "Moved/Relocated",
  "Inactive",
];
